import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { ContainerRespose, RequestContainers } from '../model/http/container-selector.model';
import { ConsumeService } from './consume.service';

@Injectable({
  providedIn: 'root'
})
export class ContainerService {

  constructor(private consume: ConsumeService) { }

  getContainers(requestContainers: RequestContainers): Observable<ContainerRespose> {
    return this.consume.httpPost(Endpoints.containers.getContainers, requestContainers);
  }

}
